// Functions for reading and writing comments from the Firestore database.

import firebase from "./firebase";
import { firestore as db } from "./firebase";
import { AuthenticatedUser } from "./users";
import { Statement } from "./statements";
import { BaseModel } from "./models";

export const COLLECTION_COMMENTS: string = "comments";

export const commentTypes = {
  COMMENT: "comment",
  ACTION: "action",
  PROPOSAL: "proposal",
};

// The CommentModel type defines how the comment is saved in the Firestore database.
export type Comment = BaseModel & {
  text: string;
  author: {
    userId: string;
    avatar: string;
    displayname: string;
    groupAccount: boolean;
  };
  statement: {
    statementId: string;
    title: string;
    status: string;
    slug: string;
  };
  likesCount?: number;
  type: string;
};

export function getComments(
  statementId: string,
  setComments: (comments: Comment[]) => void
): () => void {
  return db
    .collection(COLLECTION_COMMENTS)
    .where("statement.statementId", "==", statementId)
    .orderBy("timestamp", "desc")
    .onSnapshot((snapshot) => {
      let data: Comment[] = [];
      snapshot.forEach((doc) => {
        // Do not return proposals.
        const comment = { ...doc.data() } as any;
        if (
          comment.type === commentTypes.COMMENT ||
          comment.type === commentTypes.ACTION
        )
          data.push(comment);
      });
      setComments(data);
    });
}

export function saveComment(
  statement: Statement,
  comment: Comment,
  user: AuthenticatedUser
): void {
  const document = db.collection(COLLECTION_COMMENTS).doc();

  const commentDocument: Comment = {
    id: document.id,
    timestamp: firebase.firestore.Timestamp.now(),
    text: comment.text,
    author: {
      userId: user.id,
      displayname: user.displayname,
      groupAccount: user.groupAccount,
      avatar: user.avatar,
    },
    statement: {
      statementId: statement.id,
      title: statement.title,
      status: statement.status,
      slug: statement.slug,
    },
    type: comment.type,
  };

  document.set(commentDocument);
}

export async function deleteComment(commentId: string) {
  await db.collection(COLLECTION_COMMENTS).doc(commentId).delete();
}
